// extracted by mini-css-extract-plugin
module.exports = {"logo":"HeaderLogo_logo__pcBqU","logoMobile":"HeaderLogo_logoMobile__uy1G1","wrapper":"HeaderLogo_wrapper__d84M1"};